export const MAX_SECONDS = 10;

export const grabFrame = (video, w = 360) =>
  new Promise((res) => {
    const c = document.createElement("canvas");
    const ratio = video.videoHeight && video.videoWidth ? video.videoHeight / video.videoWidth : 0.5625;
    c.width = w;
    c.height = Math.round(w * ratio);
    c.getContext("2d").drawImage(video, 0, 0, c.width, c.height);
    c.toBlob((b) => res(b), "image/jpeg", 0.8);
  });

const once = (el, ev) =>
  new Promise((res, rej) => {
    const t = setTimeout(() => rej(new Error("We couldn't read this video. Try another one.")), 10000);
    el.addEventListener(ev, () => { clearTimeout(t); res(); }, { once: true });
    el.addEventListener("error", () => { clearTimeout(t); rej(new Error("We couldn't read this video. Try another one.")); }, { once: true });
  });

export async function probeVideo(file) {
  const url = URL.createObjectURL(file);
  const v = document.createElement("video");
  v.muted = true;
  v.playsInline = true;
  v.preload = "auto";
  v.src = url;
  try {
    await once(v, "loadedmetadata");
    await v.play().catch(() => {});
    v.pause();
    let duration = v.duration;
    if (!Number.isFinite(duration)) {
      v.currentTime = 1e7;
      await once(v, "seeked");
      duration = v.duration;
    }
    const frames = [];
    if (duration <= MAX_SECONDS + 0.5) {
      for (const t of [0.15, 0.5, 0.85]) {
        v.currentTime = Math.max(0, Math.min(duration * t, duration - 0.05));
        await once(v, "seeked");
        frames.push(await grabFrame(v));
      }
    }
    return { duration, frames };
  } finally {
    URL.revokeObjectURL(url);
  }
}
